import React, { Component } from "react";

import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import Typography from "@material-ui/core/Typography";
import Button from "components/CustomButtons/Button.jsx";
import DocListItem from "components/DocList/DocListItem";
import GlobalValue from "GlobalValue";
import axios from "axios";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Search from "@material-ui/icons/Search";
import InputAdornment from "@material-ui/core/InputAdornment";

import SaveAlt from "@material-ui/icons/SaveAlt";
const imgOn = require("assets/image/check_on.png");
const imgOff = require("assets/image/check_off_g.png");
// core components
function Transition(props) {
  return <Slide direction="up" {...props} />;
}
const styles = theme => ({
  root: {
    width: "100%",
    maxWidth: 500,
    backgroundColor: theme.palette.background.paper,
    position: "relative",
    overflow: "auto",
    maxHeight: 300
  },
  listSection: {
    backgroundColor: "inherit"
  },
  ul: {
    backgroundColor: "inherit",
    padding: 0
  },

  div: {
    height: "600px",
    width: "500px",
    backgroundColor: "#e1e1e1"
  },
  itmCheckedImg: {
    width: "35px",
    height: "35px"
    // position: "absolute",
    // right: 0,
    // top: "15px"
    // background: "1 solid #000"
    // textAlign: "right"
    // backgroundColor: "#000"
  },
  empImg: {
    backgroundColor: "#fff",
    width: "40px",
    height: "40px",
    borderRadius: "20px"
  },
  tempList: {
    paddingRight: "10px"
  },
  stNameStyle: {
    fontWeight: "600"
  },
  jcodeStyle: {
    color: "#858584",
    fontSize: "10px"
  },
  itemContaner: {
    display: "flex",
    justifyContents: "space-between",
    alignItems: "center",
    width: "100%",
    height: "100%"
  },
  item: {
    // backgroundColor: "#000",
    flex: 1
  }
});
class EmpList extends Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = { openDialog: this.props.openDialog, empName: "" };
  }

  handleClose = () => {
    this.props.handleEdocEmpListClose();
  };
  handleChangeEmpName = e => {
    let nextState = {};
    nextState[e.target.name] = e.target.value;
    this.setState(nextState);
    this.changeName(e.target.value);
  };
  itemClicked = item => {
    var tempList = this.state.selectListFilteredItem;
    for (var i = 0; i < tempList.length; i++) {
      for (var j = 0; j < tempList[i].data.length; j++) {
        if (tempList[i].data[j].SUCODE === item.SUCODE) {
          tempList[i].data[j].checkYN === imgOn
            ? (tempList[i].data[j].checkYN = imgOff)
            : (tempList[i].data[j].checkYN = imgOn);
        }
      }
    }
    this.setState({
      selectListFilteredItem: tempList
    });
  };
  changeName = async name => {
    let serchText = name;
    // let tempList = this.state.selectListFilteredItem.filter(item => {
    //   return item.data.filter(data => {
    //     return data.STNameKor.indexOf(serchText) > -1;
    //   });
    // });
    let tempList = this.state.selectListItem.map(item => {
      return {
        title: item.title,
        code: item.code,
        data: item.data.filter(c => {
          return c.SUNAME.indexOf(serchText) > -1;
        })
      };
    });
    // console.log(tempList);
    this.setState({ selectListFilteredItem: tempList });
  };
  handleSubmit = async () => {
    await this.changeName("");
    let checkedEmp = [];
    for (var i = 0; i < this.state.selectListFilteredItem.length; i++) {
      for (
        var j = 0;
        j < this.state.selectListFilteredItem[i].data.length;
        j++
      ) {
        if (this.state.selectListFilteredItem[i].data[j].checkYN === imgOn) {
          checkedEmp.push(this.state.selectListFilteredItem[i].data[j]);
        }
      }
    }
    // .data[0].filter(c => {
    //   return c.checkYN === imgOn;
    // });
    // console.log("?", checkedEmp);
    if (checkedEmp.length > 0) {
      this.props.addRef(checkedEmp);
    } else {
      alert("받는사람을 선택해주세요");
    }
  };
  componentDidMount() {
    // console.log("GLO", GlobalValue.buseo, GlobalValue.jikcheck);
    // console.log(this.props);
    let User = this.props.refList;
    let sysCompany = this.props.sysCompany;
    let tempselectListItem = [];
    for (var i = 0; i < sysCompany.length; i++) {
      var empList = [];
      for (var u = 0; u < User.length; u++) {
        User[u].checkYN = imgOff;
        if (User[u].SUSCCODE === sysCompany[i].SCCODE) {
          empList.push(User[u]);
        }
      }
      tempselectListItem.push({
        title: sysCompany[i].SCNAME,
        code: sysCompany[i].SCCODE,
        data: empList
      });
    }
    this.setState({
      selectListItem: tempselectListItem,
      selectListFilteredItem: tempselectListItem
    });
    // console.log("comcpo", tempselectListItem);
  }

  extention(filename) {
    return /[.]/.exec(filename) ? /[^.]+$/.exec(filename) : undefined;
  }
  titleClick = gubun => {
    switch (gubun) {
      case "A":
        var tempList = this.state.selectListFilteredItem;
        var checkAll = true;
        tempList[0].data[0].checkYN === imgOn
          ? (checkAll = true)
          : (checkAll = false);
        for (var i = 0; i < tempList.length; i++) {
          for (var j = 0; j < tempList[i].data.length; j++) {
            checkAll
              ? (tempList[i].data[j].checkYN = imgOff)
              : (tempList[i].data[j].checkYN = imgOn);
          }
        }
        this.setState({
          selectListFilteredItem: tempList
        });
        break;
      default: {
        // console.log(gubun);
        var tempList = this.state.selectListFilteredItem;
        var checkAll = true;
        gubun.data[0].checkYN === imgOn
          ? (checkAll = true)
          : (checkAll = false);
        for (var i = 0; i < tempList.length; i++) {
          for (var j = 0; j < tempList[i].data.length; j++) {
            if (tempList[i].code === gubun.code) {
              checkAll
                ? (tempList[i].data[j].checkYN = imgOff)
                : (tempList[i].data[j].checkYN = imgOn);
            }
          }
        }
        this.setState({
          selectListFilteredItem: tempList
        });
      }
    }
  };
  render() {
    const { classes, ...rest } = this.props;
    const LISTITEM = this.state.selectListFilteredItem
      ? this.state.selectListFilteredItem.filter(item => item.data.length > 0)
      : null;
    // console.log(LISTITEM);
    return (
      <div className={classes.div}>
        <DialogTitle id="alert-dialog-slide-title">
          <label>회원사 목록</label>
          <CustomInput
            labelText="회사명"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              inputRef: this.txtpwRef,
              value: this.state.txtPw,
              type: "text",
              name: "empName",
              endAdornment: (
                <InputAdornment position="end">
                  <Search className={classes.inputIconsColor} />
                </InputAdornment>
              ),
              onChange: this.handleChangeEmpName
            }}
          />
        </DialogTitle>
        <div>
          <DialogContent>
            {LISTITEM ? (
              <List className={classes.root} subheader={<li />}>
                <ListSubheader
                  style={{
                    flexDirection: "row",
                    display: "flex",
                    justifyContent: "space-between"
                  }}
                >
                  {`회사명`}
                  <button
                    style={{ borderRadius: "10px" }}
                    onClick={() => this.titleClick("A")}
                  >
                    일괄선택
                  </button>
                </ListSubheader>
                {LISTITEM.map((sectionId, index) => {
                  // console.log(sectionId);
                  return (
                    <li key={index} className={classes.listSection}>
                      <ul className={classes.ul}>
                        <ListSubheader
                          style={{
                            flexDirection: "row",
                            display: "flex",
                            justifyContent: "space-between"
                          }}
                        >
                          {sectionId.title}{" "}
                          <button
                            style={{ borderRadius: "10px" }}
                            onClick={() => this.titleClick(sectionId)}
                          >
                            일괄선택
                          </button>
                        </ListSubheader>
                        {sectionId.data.map((item, idx) => {
                          return (
                            <ListItem
                              key={idx}
                              onClick={() => this.itemClicked(item)}
                            >
                              <div className={classes.itemContaner}>
                                <div className={classes.item}>
                                  <img
                                    className={classes.empImg}
                                    src={
                                      item.SUMyPicYN === "Y"
                                        ? GlobalValue.PICTURE_URL +
                                          item.MyPicURL2
                                        : require("assets/image/join_no_photo.png")
                                    }
                                  />
                                </div>
                                <div className={classes.item}>
                                  <label className={classes.stNameStyle}>
                                    {item.SUNAME}
                                  </label>
                                </div>
                                <div className={classes.item}>
                                  <label className={classes.jcodeStyle}>
                                    {item.SUHP}
                                  </label>
                                </div>
                                <div className={classes.item}>
                                  {/* <label className={classes.jcodeStyle}>
                                    {item.STJCode
                                      ? GlobalValue.jikcheck.filter(
                                          j => j.JCode === item.STJCode
                                        )[0].JName
                                      : null}
                                  </label> */}
                                </div>
                                <div className={classes.item}>
                                  <img
                                    src={item.checkYN}
                                    className={classes.itmCheckedImg}
                                  />
                                </div>
                              </div>
                            </ListItem>
                          );
                        })}
                      </ul>
                    </li>
                  );
                })}
              </List>
            ) : (
              <label>내용없음</label>
            )}
          </DialogContent>
        </div>
        <DialogActions>
          <Button onClick={this.handleClose} color="cancel">
            취소
          </Button>
          <Button onClick={this.handleSubmit} color="submit">
            확인
          </Button>
        </DialogActions>
      </div>
    );
  }
}

EmpList.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(EmpList);
